import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from '../_authenticated'
import { NotificationSettings } from '@/pages/settings'

export const notificationSettingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/settings/notifications',
  component: NotificationSettings,
})
